import React, { useEffect, useState } from 'react'
import TitleWithBackNavigation from '../../../../components/TitleWithBackNavigation'
import { useDispatch, useSelector } from 'react-redux'
import { fetchBlockUsers } from '../../../../store/common/settingSlice';
import { Avatar, Col, Row } from 'antd';
import FullPageLoader from '../../../../components/FullPageLoader';
import { UserOutlined } from '@ant-design/icons';
import Button from '../../../../components/FormElements/Button';
import cardIcon from '../../../../assets/images/cardIcon.png'
import { useMutation } from 'react-query';
import axiosInstance from '../../../../config/api';
import { setError, setMessage } from '../../../../store/common/generalSlice';

const BlockUsers = () => {

    const { blockUsers, loading } = useSelector(state => state?.setting);
    const [blockUserId, setBlockUserId] = useState(null)
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchBlockUsers())
    }, [])

    const blockMutation = useMutation(async (id) => {
        let resp = await axiosInstance.post('/user/block-unblock', { otherUserId: id });
        return resp
    },
        {
            onSuccess: (resp) => {
                dispatch(setMessage(resp?.data?.data?.message));
                dispatch(fetchBlockUsers())
            },
            onError: (error) => {
                dispatch(setError(error?.response?.data?.error?.message))
            }
        }
    )

    const unblockHandler = (id) => {
        setBlockUserId(id)
        blockMutation.mutate(id)
    }

    return (
        <div className='w-full'>
            <TitleWithBackNavigation title={'Block User'} link={'/settings'} />
            <Row className='w-full py-4'>
                {
                    loading ?
                        <FullPageLoader />
                        :
                        <Row className='w-full grid gap-3 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'>
                            {
                                blockUsers?.length > 0 ?
                                    blockUsers?.map((blockUser) => {
                                        return (
                                            <Col className='bg-white rounded-md block-users px-3 py-4 flex items-start gap-3 relative' key={blockUser?.id}>
                                                {
                                                    blockUser?.blockeduser?.imageThumbUrl ?
                                                        <Avatar src={blockUser?.blockeduser?.imageThumbUrl} size={45} />
                                                        :
                                                        <Avatar icon={<UserOutlined />} shape='circle' size={45} />
                                                }
                                                <div className='flex flex-col gap-1'>
                                                    <p className='font-semibold text-md'>{blockUser?.blockeduser?.fullName ? blockUser?.blockeduser?.fullName?.length > 13 ? blockUser?.blockeduser?.fullName + '...' : blockUser?.blockeduser?.fullName : '-'}</p>
                                                    <Button.Basic
                                                        text={'Un-Block'}
                                                        loading={(blockUserId == blockUser?.blockeduser?.id && blockMutation?.isLoading) ? true : false}
                                                        size={'small'}
                                                        classes={'bg-[#fab700] text-white w-fit submit-btn'}
                                                        disabled={(blockUserId !== blockUser?.blockeduser?.id && blockMutation?.isLoading) ? true : false}
                                                        onClick={() => unblockHandler(blockUser?.blockeduser?.id)}
                                                    />
                                                </div>
                                                <img src={cardIcon} className='h-8 w-8 self-start absolute top-2 right-2' />
                                            </Col>
                                        )
                                    })
                                    :
                                    <p>No Block users available</p>
                            }
                        </Row>
                }
            </Row>
        </div>
    )
}

export default BlockUsers